var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 92,
    viewBox: "0 0 101 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45435 34.8749C3.31072 34.8889 3.99479 35.5957 3.98083 36.4521C3.96688 37.3085 3.26014 37.9926 2.40377 37.9787C1.54739 37.9647 0.863323 37.2579 0.877279 36.4015C0.891236 35.5451 1.59797 34.861 2.45435 34.8749Z",
    fill: "url(#paint0_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73831 17.4501C3.59469 17.4641 4.27876 18.1708 4.2648 19.0272C4.25084 19.8837 3.54411 20.5678 2.68773 20.5539C1.83136 20.5399 1.14729 19.8331 1.16125 18.9767C1.1752 18.1202 1.88194 17.4362 2.73831 17.4501Z",
    fill: "url(#paint1_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02226 0.0254244C3.87864 0.0393802 4.56271 0.746139 4.54875 1.60257C4.5348 2.45899 3.82806 3.14313 2.97168 3.12917C2.11531 3.11521 1.43124 2.40842 1.4452 1.55199C1.45915 0.695563 2.16589 0.0114685 3.02226 0.0254244Z",
    fill: "url(#paint2_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4357 35.1353C19.2921 35.1492 19.9762 35.856 19.9622 36.7125C19.9482 37.5689 19.2415 38.253 18.3851 38.239C17.5288 38.2251 16.8447 37.5183 16.8586 36.6619C16.8726 35.8055 17.5793 35.1213 18.4357 35.1353Z",
    fill: "url(#paint3_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7197 17.7104C19.5761 17.7243 20.2601 18.4311 20.2462 19.2875C20.2322 20.1439 19.5255 20.8281 18.6691 20.8141C17.8127 20.8002 17.1287 20.0934 17.1426 19.2369C17.1566 18.3805 17.8633 17.6964 18.7197 17.7104Z",
    fill: "url(#paint4_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0036 0.285678C19.86 0.299634 20.5441 1.00639 20.5301 1.86282C20.5161 2.71925 19.8094 3.40338 18.953 3.38942C18.0967 3.37547 17.4126 2.66867 17.4266 1.81224C17.4405 0.955817 18.1472 0.271722 19.0036 0.285678Z",
    fill: "url(#paint5_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4171 35.3957C35.2734 35.4096 35.9575 36.1164 35.9435 36.9728C35.9296 37.8293 35.2228 38.5134 34.3665 38.4994C33.5101 38.4855 32.826 37.7787 32.84 36.9223C32.8539 36.0658 33.5607 35.3817 34.4171 35.3957Z",
    fill: "url(#paint6_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2274 19.5545C36.2414 18.6974 35.558 17.9913 34.7009 17.9773C33.8439 17.9634 33.1378 18.6468 33.1239 19.5039C33.1099 20.361 33.7933 21.0671 34.6504 21.0811C35.5074 21.095 36.2135 20.4115 36.2274 19.5545Z",
    fill: "url(#paint7_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5115 2.12344C36.5255 1.26637 35.842 0.560265 34.985 0.546298C34.128 0.532332 33.4219 1.21579 33.4079 2.07286C33.394 2.92994 34.0774 3.63608 34.9344 3.65004C35.7914 3.66401 36.4975 2.98051 36.5115 2.12344Z",
    fill: "url(#paint8_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3984 35.6562C51.2548 35.6701 51.9389 36.3769 51.9249 37.2333C51.911 38.0898 51.2042 38.7739 50.3479 38.7599C49.4915 38.746 48.8074 38.0392 48.8214 37.1828C48.8353 36.3263 49.5421 35.6422 50.3984 35.6562Z",
    fill: "url(#paint9_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6824 18.2314C51.5388 18.2453 52.2228 18.9521 52.2089 19.8085C52.1949 20.6649 51.4882 21.3491 50.6318 21.3351C49.7755 21.3211 49.0914 20.6143 49.1054 19.7579C49.1193 18.9015 49.826 18.2174 50.6824 18.2314Z",
    fill: "url(#paint10_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9664 0.806674C51.8228 0.82063 52.5068 1.52739 52.4929 2.38382C52.4789 3.24024 51.7722 3.92438 50.9158 3.91042C50.0595 3.89646 49.3754 3.18967 49.3893 2.33324C49.4033 1.47681 50.11 0.792719 50.9664 0.806674Z",
    fill: "url(#paint11_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5278 88.1973C66.3841 88.2113 67.0682 88.918 67.0543 89.7744C67.0403 90.6309 66.3336 91.315 65.4772 91.301C64.6208 91.2871 63.9367 90.5803 63.9507 89.7239C63.9647 88.8674 64.6714 88.1833 65.5278 88.1973Z",
    fill: "url(#paint12_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3382 72.3498C67.3522 71.4927 66.6688 70.7866 65.8117 70.7726C64.9547 70.7587 64.2486 71.4421 64.2347 72.2992C64.2207 73.1563 64.9041 73.8624 65.7612 73.8764C66.6182 73.8903 67.3243 73.2068 67.3382 72.3498Z",
    fill: "url(#paint13_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6222 54.925C67.6362 54.0679 66.9528 53.3618 66.0958 53.3478C65.2387 53.3338 64.5327 54.0173 64.5187 54.8744C64.5047 55.7315 65.1881 56.4376 66.0452 56.4516C66.9022 56.4655 67.6083 55.782 67.6222 54.925Z",
    fill: "url(#paint14_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3798 35.9167C67.2362 35.9306 67.9202 36.6374 67.9063 37.4938C67.8923 38.3503 67.1856 39.0344 66.3292 39.0204C65.4728 39.0064 64.7888 38.2997 64.8027 37.4433C64.8167 36.5868 65.5234 35.9027 66.3798 35.9167Z",
    fill: "url(#paint15_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1901 20.0755C68.2041 19.2184 67.5207 18.5123 66.6637 18.4983C65.8066 18.4844 65.1006 19.1678 65.0866 20.0249C65.0726 20.882 65.7561 21.5881 66.6131 21.6021C67.4701 21.616 68.1762 20.9325 68.1901 20.0755Z",
    fill: "url(#paint16_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4742 2.64444C68.4882 1.78736 67.8047 1.08126 66.9477 1.06729C66.0907 1.05333 65.3846 1.73678 65.3706 2.59386C65.3567 3.45093 66.0401 4.15707 66.8971 4.17104C67.7542 4.18501 68.4602 3.50151 68.4742 2.64444Z",
    fill: "url(#paint17_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5156 88.4579C82.3719 88.4719 83.056 89.1786 83.042 90.0351C83.0281 90.8915 82.3214 91.5756 81.465 91.5617C80.6086 91.5477 79.9245 90.8409 79.9385 89.9845C79.9524 89.1281 80.6592 88.444 81.5156 88.4579Z",
    fill: "url(#paint18_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.326 72.6103C83.34 71.7532 82.6565 71.0471 81.7995 71.0331C80.9425 71.0191 80.2364 71.7026 80.2224 72.5597C80.2085 73.4168 80.8919 74.1229 81.7489 74.1369C82.6059 74.1508 83.312 73.4673 83.326 72.6103Z",
    fill: "url(#paint19_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6099 55.1856C83.6239 54.3285 82.9405 53.6224 82.0834 53.6084C81.2264 53.5945 80.5203 54.2779 80.5064 55.135C80.4924 55.9921 81.1758 56.6982 82.0329 56.7122C82.8899 56.7261 83.596 56.0426 83.6099 55.1856Z",
    fill: "url(#paint20_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3675 36.1773C83.2239 36.1912 83.908 36.898 83.894 37.7545C83.8801 38.6109 83.1733 39.295 82.317 39.281C81.4606 39.2671 80.7765 38.5603 80.7905 37.7039C80.8044 36.8475 81.5112 36.1633 82.3675 36.1773Z",
    fill: "url(#paint21_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1779 20.3361C84.1918 19.479 83.5084 18.7729 82.6514 18.7589C81.7944 18.745 81.0883 19.4284 81.0743 20.2855C81.0603 21.1426 81.7438 21.8487 82.6008 21.8627C83.4578 21.8767 84.1639 21.1932 84.1779 20.3361Z",
    fill: "url(#paint22_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4619 2.90493C84.4759 2.04786 83.7925 1.34176 82.9355 1.32779C82.0784 1.31383 81.3724 1.99728 81.3584 2.85436C81.3444 3.71143 82.0279 4.41757 82.8849 4.43154C83.7419 4.4455 84.448 3.76201 84.4619 2.90493Z",
    fill: "url(#paint23_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4969 88.7183C98.3533 88.7323 99.0373 89.439 99.0234 90.2954C99.0094 91.1519 98.3027 91.836 97.4463 91.822C96.5899 91.8081 95.9059 91.1013 95.9199 90.2449C95.9338 89.3884 96.6405 88.7043 97.4969 88.7183Z",
    fill: "url(#paint24_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3073 72.8706C99.3213 72.0136 98.6378 71.3075 97.7808 71.2935C96.9238 71.2795 96.2177 71.963 96.2038 72.8201C96.1898 73.6771 96.8732 74.3833 97.7302 74.3972C98.5873 74.4112 99.2933 73.7277 99.3073 72.8706Z",
    fill: "url(#paint25_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5913 55.4459C99.6053 54.5889 98.9218 53.8828 98.0648 53.8688C97.2078 53.8548 96.5017 54.5383 96.4878 55.3954C96.4738 56.2524 97.1572 56.9586 98.0142 56.9726C98.8712 56.9865 99.5773 56.303 99.5913 55.4459Z",
    fill: "url(#paint26_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3489 36.4377C99.2052 36.4516 99.8893 37.1584 99.8754 38.0148C99.8614 38.8713 99.1547 39.5554 98.2983 39.5414C97.4419 39.5274 96.7579 38.8207 96.7718 37.9643C96.7858 37.1078 97.4925 36.4237 98.3489 36.4377Z",
    fill: "url(#paint27_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.159 20.5965C100.173 19.7394 99.4898 19.0333 98.6327 19.0193C97.7757 19.0054 97.0697 19.6888 97.0557 20.5459C97.0417 21.403 97.7251 22.1091 98.5822 22.1231C99.4392 22.137 100.145 21.4535 100.159 20.5965Z",
    fill: "url(#paint28_linear_309_152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.443 3.16531C100.457 2.30824 99.7738 1.60213 98.9168 1.58817C98.0598 1.5742 97.3537 2.25766 97.3397 3.11473C97.3258 3.97181 98.0092 4.67795 98.8662 4.69191C99.7232 4.70588 100.429 4.02238 100.443 3.16531Z",
    fill: "url(#paint29_linear_309_152)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_309_152",
    x1: 1.42097,
    y1: 37.9626,
    x2: 2.91496,
    y2: 35.1929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_309_152",
    x1: 1.70494,
    y1: 20.5378,
    x2: 3.19893,
    y2: 17.7681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_309_152",
    x1: 1.98889,
    y1: 3.11315,
    x2: 3.48288,
    y2: 0.343461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_309_152",
    x1: 17.4023,
    y1: 38.223,
    x2: 18.8963,
    y2: 35.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_309_152",
    x1: 17.6863,
    y1: 20.7981,
    x2: 19.1803,
    y2: 18.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_309_152",
    x1: 17.9702,
    y1: 3.37341,
    x2: 19.4642,
    y2: 0.603714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_309_152",
    x1: 33.3837,
    y1: 38.4834,
    x2: 34.8777,
    y2: 35.7137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_309_152",
    x1: 33.6676,
    y1: 21.0651,
    x2: 35.1616,
    y2: 18.2954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_309_152",
    x1: 33.9516,
    y1: 3.63403,
    x2: 35.4456,
    y2: 0.864335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_309_152",
    x1: 49.3651,
    y1: 38.7439,
    x2: 50.8591,
    y2: 35.9742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_309_152",
    x1: 49.649,
    y1: 21.3191,
    x2: 51.143,
    y2: 18.5494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_309_152",
    x1: 49.933,
    y1: 3.8944,
    x2: 51.427,
    y2: 1.12472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_309_152",
    x1: 64.4944,
    y1: 91.285,
    x2: 65.9884,
    y2: 88.5153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_309_152",
    x1: 64.7784,
    y1: 73.8603,
    x2: 66.2724,
    y2: 71.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_309_152",
    x1: 65.0624,
    y1: 56.4355,
    x2: 66.5564,
    y2: 53.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_309_152",
    x1: 65.3464,
    y1: 39.0044,
    x2: 66.8404,
    y2: 36.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_309_152",
    x1: 65.6303,
    y1: 21.5861,
    x2: 67.1243,
    y2: 18.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_309_152",
    x1: 65.9143,
    y1: 4.15502,
    x2: 67.4083,
    y2: 1.38533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_309_152",
    x1: 80.4822,
    y1: 91.5456,
    x2: 81.9762,
    y2: 88.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_309_152",
    x1: 80.7661,
    y1: 74.1208,
    x2: 82.2601,
    y2: 71.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_309_152",
    x1: 81.0501,
    y1: 56.6962,
    x2: 82.5441,
    y2: 53.9265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_309_152",
    x1: 81.3342,
    y1: 39.265,
    x2: 82.8281,
    y2: 36.4953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_309_152",
    x1: 81.618,
    y1: 21.8467,
    x2: 83.112,
    y2: 19.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_309_152",
    x1: 81.9021,
    y1: 4.41552,
    x2: 83.3961,
    y2: 1.64583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_309_152",
    x1: 96.4635,
    y1: 91.806,
    x2: 97.9575,
    y2: 89.0363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_309_152",
    x1: 96.7475,
    y1: 74.3812,
    x2: 98.2415,
    y2: 71.6115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_309_152",
    x1: 97.0314,
    y1: 56.9565,
    x2: 98.5254,
    y2: 54.1869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_309_152",
    x1: 97.3155,
    y1: 39.5254,
    x2: 98.8095,
    y2: 36.7557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_309_152",
    x1: 97.5994,
    y1: 22.1071,
    x2: 99.0934,
    y2: 19.3374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_309_152",
    x1: 97.8834,
    y1: 4.6759,
    x2: 99.3774,
    y2: 1.90621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotVector);
export default __webpack_public_path__ + "static/media/dot-vector.7af725c1f8246fef579df5b182751393.svg";
export { ForwardRef as ReactComponent };